import React, { FC } from 'react';
import Button from 'shared/components/andtComponents/Button';
import styles from './TableHeader.module.scss';

interface RowsDropdownProps {
  itemsPerPage: { label: string; value: number };
  rowsOptions: Array<{ label: string; value: number }>;
  openRowsDropdown: boolean;
  setItemsPerPage: (option: { label: string; value: number }) => void;
  setOpenRowsDropdown: (open: boolean) => void;
}

const GovernanceTagsRowsDropdown: FC<RowsDropdownProps> = ({
  itemsPerPage,
  rowsOptions,
  openRowsDropdown,
  setItemsPerPage,
  setOpenRowsDropdown,
}) => {
  return (
    <div className={styles.rowsDropdownContainer}>
      <Button
        text={`Rows (${itemsPerPage.value})`}
        isSecondary
        automationid="rows-per-page"
        className={styles.headerButton}
        onClick={() => setOpenRowsDropdown(!openRowsDropdown)}
      />
      {openRowsDropdown && (
        <div className={styles.rowsDropdown}>
          {rowsOptions.map((option) => (
            <div
              key={option.value}
              className={styles.rowsDropdownItem}
              onClick={() => {
                setItemsPerPage(option);
                setOpenRowsDropdown(false);
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GovernanceTagsRowsDropdown;
